import { LEGACY_STAT_KEY_BY_FORMULA } from '@/tableBuilder/scorecard.constants';
import type { RehydratedScorecardState, ScorecardState } from '@/tableBuilder/scorecard.store';
import type { ScorecardMetric } from '@/tableBuilder/scorecard.types';

/** A metric as persisted by older worksteps, before stats were parameterized (`formula`/`timeUnits` instead of `stat`). */
type LegacyScorecardMetric = Partial<ScorecardMetric> & {
  formula?: string;
  timeUnits?: string | null;
};

/**
 * Upgrades a persisted metric to the current shape: derives `stat` from a legacy `formula` when missing,
 * and defaults `stat.timeUnits` to seconds. Already-current metrics keep their `stat` untouched.
 */
export const normalizeMetric = (metric: LegacyScorecardMetric): ScorecardMetric => {
  const nextMetric = structuredClone(metric) as ScorecardMetric;

  if (!nextMetric.stat) {
    nextMetric.stat = {
      key: metric.formula ? (LEGACY_STAT_KEY_BY_FORMULA[metric.formula] ?? null) : null,
      timeUnits: metric.timeUnits ?? null,
    };
  }

  if (!nextMetric.stat.timeUnits) {
    nextMetric.stat = {
      ...nextMetric.stat,
      timeUnits: 's',
    };
  }

  return nextMetric;
};

export const normalizeScorecardState = (dehydratedState?: RehydratedScorecardState): ScorecardState => ({
  metrics: (dehydratedState?.metrics ?? []).map((metric) => normalizeMetric(metric)),
});
